import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class EmploymentProfessionalHistory extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_employment_professional_history');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'current_employer')}><i class="fas fa-file-download"></i> Current Employer / Law Firm</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'past_employment_history')}><i class="fas fa-file-download"></i> Past Employment History</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'key_clients_or_cases_handled')}><i class="fas fa-file-download"></i> Key Clients or Cases Handled</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'professional_memberships')}><i class="fas fa-file-download"></i> Professional Memberships</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'part_time_employee_employment_professional_history';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
    }else{
      url = "/php/admin_part_time_employee_management_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){

    $('#old_current_employer').val(data['current_employer_new_name']);
    $('#old_past_employment_history').val(data['past_employment_history_new_name']);
    $('#old_key_clients_or_cases_handled').val(data['key_clients_or_cases_handled_new_name']);
    $('#old_professional_memberships').val(data['professional_memberships_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['png','jpg','jpeg','JPEG','JPG','PNG','pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());


    var current_employer_temp    = window.isNullAndUndef($('#current_employer').val());
    var org_current_employer     = $("#current_employer").prop("files")[0];
    var current_employer_name    = $('#current_employer').val().split('\\').pop();

    var past_employment_history_temp        = window.isNullAndUndef($('#past_employment_history').val());
    var org_past_employment_history         = $("#past_employment_history").prop("files")[0];
    var past_employment_history_name        = $('#past_employment_history').val().split('\\').pop();

    var key_clients_or_cases_handled_temp        = window.isNullAndUndef($('#key_clients_or_cases_handled').val());
    var org_key_clients_or_cases_handled         = $("#key_clients_or_cases_handled").prop("files")[0];
    var key_clients_or_cases_handled_name        = $('#key_clients_or_cases_handled').val().split('\\').pop();

    var professional_memberships_temp        = window.isNullAndUndef($('#professional_memberships').val());
    var org_professional_memberships         = $("#professional_memberships").prop("files")[0];
    var professional_memberships_name        = $('#professional_memberships').val().split('\\').pop();


    var current_employer_ext    = '';
    var past_employment_history_ext  = '';
    var key_clients_or_cases_handled_ext  = '';
    var professional_memberships_ext  = '';

    if(current_employer_temp && past_employment_history_temp && key_clients_or_cases_handled_temp && professional_memberships_temp){
      current_employer_ext       = current_employer_temp.split('.').pop();
      past_employment_history_ext        = past_employment_history_temp.split('.').pop();
      key_clients_or_cases_handled_ext        = key_clients_or_cases_handled_temp.split('.').pop();
      professional_memberships_ext        = professional_memberships_temp.split('.').pop();
    }
    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(file_main_ext.indexOf(current_employer_ext) >= 0 && file_main_ext.indexOf(past_employment_history_ext) >= 0 && file_main_ext.indexOf(key_clients_or_cases_handled_ext) >= 0 && file_main_ext.indexOf(professional_memberships_ext) >= 0){
      var old_current_employer                 = $('#old_current_employer').val();
      var old_past_employment_history                  = $('#old_past_employment_history').val();
      var old_key_clients_or_cases_handled                  = $('#old_key_clients_or_cases_handled').val();
      var old_professional_memberships                  = $('#old_professional_memberships').val();
      var all_data                              = {};


      all_data['current_employer']             = window.return_false_null(current_employer_name);
      all_data['past_employment_history']                 = window.return_false_null(past_employment_history_name);
      all_data['key_clients_or_cases_handled']                 = window.return_false_null(key_clients_or_cases_handled_name);
      all_data['professional_memberships']                 = window.return_false_null(professional_memberships_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('current_employer',org_current_employer);
      body.append('old_current_employer',old_current_employer);
      body.append('past_employment_history',org_past_employment_history);
      body.append('old_past_employment_history',old_past_employment_history);
      body.append('key_clients_or_cases_handled',org_key_clients_or_cases_handled);
      body.append('old_key_clients_or_cases_handled',old_key_clients_or_cases_handled);
      body.append('professional_memberships',org_professional_memberships);
      body.append('old_professional_memberships',old_professional_memberships);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_employment_professional_history');
      body.append('function','add_part_time_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('current_employer','past_employment_history','key_clients_or_cases_handled','professional_memberships');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_current_employer" placeholder=""/>
                                        <input type="file" className="form-control" id="current_employer" placeholder="Current Employer / Law Firm"/>
                                        <label for="name">Current Employer / Law Firm</label>
                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_past_employment_history" placeholder=""/>
                                        <input type="file" className="form-control" id="past_employment_history" placeholder="Past Employment History"/>
                                        <label for="name">Past Employment History</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_key_clients_or_cases_handled" placeholder=""/>
                                        <input type="file" className="form-control" id="key_clients_or_cases_handled" placeholder="Key Clients or Cases Handled"/>
                                        <label for="name">Key Clients or Cases Handled</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_professional_memberships" placeholder=""/>
                                        <input type="file" className="form-control" id="professional_memberships" placeholder="Professional Memberships"/>
                                        <label for="name">Professional Memberships</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF, JPEG, JPG & PNG</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default EmploymentProfessionalHistory;
